/**
 * DI-2-4 — the Sync step's progress, read by the ONE status bar
 * (`feedback_progress_indication_minimal`: no per-widget spinner).
 * Ephemeral UI state (Zustand).
 */
import { createStore, useStore } from "zustand";

export interface SyncProgressState {
  /** True while a round trip is in flight. */
  active: boolean;
  sent: number;
  total: number;
  set: (p: { active: boolean; sent: number; total: number }) => void;
  reset: () => void;
}

export const syncProgressStore = createStore<SyncProgressState>()((set) => ({
  active: false,
  sent: 0,
  total: 0,
  set: (p) => {
    set(p);
  },
  reset: () => {
    set({ active: false, sent: 0, total: 0 });
  },
}));

export function useSyncProgress<T>(selector: (s: SyncProgressState) => T): T {
  return useStore(syncProgressStore, selector);
}
